import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BusinessType, TenantlessBaseEntity, WithTenantlessBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { InviteStatus } from './invite-status.enum';
import { InviteMethod } from './invite.method.enum';
import { InviteInviter, InviteInviterSchema } from './invite.inviter';

export const InviteSchema = WithTenantlessBaseEntitySchema(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
    z.object({
        status: EnumSchema(InviteStatus),
        email: z.string().email(),
        inviter: InviteInviterSchema,
        type: EnumSchema(BusinessType).optional(),
        method: EnumSchema(InviteMethod),
    }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
).strict();

export class Invite extends FromSchema(InviteSchema) implements TenantlessBaseEntity {
    id: string;
    email: string;
    status: InviteStatus;
    inviter?: InviteInviter;
    type?: BusinessType;
    method: InviteMethod;
    createdAt: Date;
    updatedAt: Date;
    createdBy: Executor;
}
